<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <producto-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import ProductoProvider from "../../../../providers/ProductoProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import ProductoForm from "../ProductoForm";
    
    


    export default {
        name: "ProductoCreate",
         
        components: { ProductoForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'cobrox.producto.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    nombre: ''
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    ProductoProvider.createProducto(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createProducto)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

